import { render, staticRenderFns } from "./advertisementfore.vue?vue&type=template&id=a51c6030&"
import script from "./advertisementfore.vue?vue&type=script&lang=js&"
export * from "./advertisementfore.vue?vue&type=script&lang=js&"
import style0 from "./advertisementfore.vue?vue&type=style&index=0&id=a51c6030&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports